import React from 'react'
import './index.less'

const tipsTexts = {
  overInventory: '以下商品加购数超库存数量',
  off: '以下商品已下架',
}

export interface ProductErrorModalProps {
  /**分类 */
  type?: 'overInventory' | 'off'
  onOk?: Function
  data?: Array<SwaggerDTO.校验无法通过的商品信息>
  tips?: string
}

export default function ProductErrorModal({
  type = 'overInventory',
  onOk,
  data,
  tips,
}: ProductErrorModalProps) {
  return (
    <div className="product-error">
      <div className="p-tips">{tips || `${tipsTexts[type]}，请重新选择:`}</div>
      <div className="p-list">
        {data?.map((item, index) => (
          <div className="p-list-item" key={index}>
            <img className="p-list-item-img" src={item?.skuCoverUrl} alt="" />
            <p className="p-list-item-title">{item?.skuName}</p>
          </div>
        ))}
      </div>
      <div className="p-footer" onClick={() => onOk?.()}>
        我知道了
      </div>
    </div>
  )
}
